import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/auth/requestMagicLink';
import config from '../../../config';
import { Error } from '../../actions/error/error';
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation(action) {
  try {
    const { email } = action.payload;
    const response = yield call(axios.post, 
      `${config.API_URL}/user/request-magic-link`,
      { email },
      { 
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );
    
    // Store email for later use in verification
    localStorage.setItem('pendingEmail', email);
    
    yield put(fetchSuccess(response.data));
  } catch (error) {
    yield put(Error(error));
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
